<template>
  <div class="keep-flow_block">
    <div class="keep-flow_wrapTitBox">
      <span class="h3">附件信息</span>
      <div class="upDownBtn">
        <van-icon size="20" color="#999999" @click="showWrapFun" v-if="showWrapStatus" name="arrow-up" />
        <van-icon size="20" color="#999999" @click="showWrapFun" v-else name="arrow-down" />
      </div>
    </div>
    <div class="keep-flow_container" v-show="showWrapStatus">
      <div class="contentBox" :class="{ packagefileCls: formConfig ? formConfig.packagefile : false }">
        <div class="content" v-html="atfileinfo"></div>
        <div class="file-list-container">
          <div class="file-list-1">
            <div class="file-list-header">
              <div class="file-list-header-left">
                <svg-icon style="width: 32px !important; height: 20px !important;" icon-class="spl_pic_fj01" />
                <span>当前审批流附件</span>
              </div>
              <div class="file-list-header-right" v-if="app_can_upload_allfile">
                <van-switch size="18px" v-model="ischangepdf" />
                <span :class="ischangepdf ? 'ischangepdfClass' : ''">office文档转pdf</span>
              </div>
            </div>
            <!-- 格式化附件 -->
            <div v-if="atfilenamelist" style="padding: 8px;">
              <div class="atFileListBox">
                <div class="atFileListList" @click.stop="clickFj(value, key)" v-for="(value, key) in atFileList"
                  :key="key">
                  <van-uploader v-model="value.list" max-count="1"
                    :accept="app_can_upload_allfile ? '' : 'image/*,.jpg,.png'" :after-read="afterRead"
                    :disabled="!canUploadFile || value.packagefile" :deletable="canDelFile"
                    :before-delete="beforeDelete" :before-read="beforeRead" :preview-options="{
                      className: 'windowImagePreviewClassName'
                    }">
                    <template
                      #preview-cover="{ type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno }">
                      <div class="preview-cover-container">
                        <div class="preview-cover" v-if="type == 'pdf'">
                          <img
                            @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                            class="iconImg" src="@/assets/img/workFlowPdf.png" alt="">
                        </div>
                        <div class="preview-cover" v-else-if="type == 'doc'">
                          <img
                            @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                            class="iconImg" src="@/assets/img/workFlowDoc.png" alt="">
                        </div>
                        <div class="preview-cover" v-else-if="type == 'xls'">
                          <img
                            @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                            class="iconImg" src="@/assets/img/workFlowXls.png" alt="">
                        </div>
                        <div class="preview-cover" v-else-if="type == 'txt'">
                          <img
                            @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                            class="iconImg" src="@/assets/img/workFlowTxt.png" alt="">
                        </div>
                        <div class="preview-cover" v-else-if="type == 'video'">
                          <img
                            @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                            class="iconImg" src="@/assets/img/workFlowVideo.png" alt="">
                        </div>
                        <div class="preview-cover" v-else-if="type == 'default' || type == 'ppt' || type == 'zip'">
                          <img
                            @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                            class="iconImg" src="@/assets/img/workFlowOther.png" alt="">
                        </div>
                        <div class="preview-cover ccc" v-else-if="type == 'pic' && documentType != 0"
                          @click.stop="ceshiEvent2(url, type, sfilename)">

                        </div>
                      </div>

                    </template>
                  </van-uploader>
                  <div class="atFileListListName" @click.stop>{{ value.sfilename }}{{
                    formConfig && formConfig.packagefile ? '(' + value.list.length+')':'' }}</div>
                </div>
              </div>
            </div>
            <!-- 非格式化附件 -->
            <div v-else style="padding: 8px;">
              <van-uploader v-model="fileList" multiple :accept="app_can_upload_allfile ? '' : 'image/*,.jpg,.png'"
                :after-read="afterRead" image-fit="contain" :disabled="!canUploadFile" :before-delete="beforeDelete"
                :deletable="canDelFile" :before-read="beforeRead" :preview-options="{
                  className: 'windowImagePreviewClassName'
                }">
                <template
                  #preview-cover="{ type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno }">
                  <div class="preview-cover" v-if="type == 'pdf'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowPdf.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'doc'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowDoc.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'xls'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowXls.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'txt'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowTxt.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'video'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowVideo.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'default' || type == 'ppt' || type == 'zip'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowOther.png" alt="">
                  </div>
                  <div class="preview-cover ccc" v-else-if="type == 'pic' && documentType != 0"
                    @click.stop="ceshiEvent(url, type, sfilename)">

                  </div>
                  <div class="preview-cover-footer van-ellipsis" @click.stop
                    v-if="sfilename && typeof sfilename == 'string'">
                    <van-notice-bar speed="15" :scrollable="computedScrollable(sfilename)" :text="sfilename" />
                  </div>
                </template>
              </van-uploader>
            </div>
          </div>
          <div class="file-list-1 hideUploadBtn" v-if="fileList2.length > 0">
            <div class="file-list-header">
              <div class="file-list-header-left">
                <svg-icon style="width: 32px !important; height: 20px !important;" icon-class="spl_pic_fj02" />
                <span>其他审批流关联附件</span>
              </div>
              <div class="file-list-header-right" v-if="app_can_upload_allfile">
                <van-switch size="18px" v-model="ischangepdf" />
                <span :class="ischangepdf ? 'ischangepdfClass' : ''">office文档转pdf</span>
              </div>
            </div>
            <div style="padding: 8px;">
              <van-uploader v-model="fileList2" multiple :accept="app_can_upload_allfile ? '' : 'image/*,.jpg,.png'"
                :after-read="afterRead" image-fit="contain" :disabled="true" :before-delete="beforeDelete"
                :deletable="false" :before-read="beforeRead" :preview-options="{
                  className: 'windowImagePreviewClassName'
                }">
                <template
                  #preview-cover="{ type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno }">
                  <div class="preview-cover" v-if="type == 'pdf'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowPdf.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'doc'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowDoc.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'xls'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowXls.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'txt'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowTxt.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'video'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowVideo.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'default' || type == 'ppt' || type == 'zip'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowOther.png" alt="">
                  </div>

                  <div class="preview-cover-footer van-ellipsis" v-if="sfilename && typeof sfilename == 'string'">
                    <van-notice-bar speed="15" :scrollable="computedScrollable(sfilename)" :text="sfilename" />
                  </div>
                </template>
              </van-uploader>
            </div>
          </div>
          <div class="file-list-1 hideUploadBtn" v-if="fileList3.length > 0">
            <div class="file-list-header">
              <div class="file-list-header-left">
                <svg-icon style="width: 32px !important; height: 20px !important;" icon-class="spl_pic_fj02" />
                <span>其他模块关联附件</span>
              </div>
              <div class="file-list-header-right" v-if="app_can_upload_allfile">
                <van-switch size="18px" v-model="ischangepdf" />
                <span :class="ischangepdf ? 'ischangepdfClass' : ''">office文档转pdf</span>
              </div>
            </div>
            <div style="padding: 8px;">
              <van-uploader v-model="fileList3" multiple :accept="app_can_upload_allfile ? '' : 'image/*,.jpg,.png'"
                :after-read="afterRead" image-fit="contain" :disabled="true" :before-delete="beforeDelete"
                :deletable="false" :before-read="beforeRead" :preview-options="{
                  className: 'windowImagePreviewClassName'
                }">
                <template
                  #preview-cover="{ type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno }">
                  <div class="preview-cover" v-if="type == 'pdf'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowPdf.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'doc'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowDoc.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'xls'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowXls.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'txt'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowTxt.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'video'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowVideo.png" alt="">
                  </div>
                  <div class="preview-cover" v-else-if="type == 'default' || type == 'ppt' || type == 'zip'">
                    <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                      class="iconImg" src="@/assets/img/workFlowOther.png" alt="">
                  </div>
                  <div class="preview-cover-footer van-ellipsis" v-if="sfilename && typeof sfilename == 'string'">
                    <van-notice-bar speed="15" :scrollable="computedScrollable(sfilename)" :text="sfilename" />
                  </div>
                </template>
              </van-uploader>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ImagesPreview v-if="showPreview" :images="imageList" :initial-index="previewIndex" @close="showPreview = false"
      @change-index="handleIndexChange" />
    <van-dialog :beforeClose="beforeClose" v-model="showPackageFile" :title="packageFileTit" show-cancel-button>
      <div class="packageFileBox">
        <van-uploader v-model="packageFileList" multiple :before-delete="beforeDelete2">
          <template #preview-cover="{ type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno }">
            <div style="width: 100%; height: 100%;" class="preview-cover-container preview-cover-container-packagefile">
              <div class="preview-cover" v-if="type == 'pdf'">
                <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                  class="iconImg" src="@/assets/img/workFlowPdf.png" alt="">
              </div>
              <div class="preview-cover" v-else-if="type == 'doc'">
                <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                  class="iconImg" src="@/assets/img/workFlowDoc.png" alt="">
              </div>
              <div class="preview-cover" v-else-if="type == 'xls'">
                <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                  class="iconImg" src="@/assets/img/workFlowXls.png" alt="">
              </div>
              <div class="preview-cover" v-else-if="type == 'txt'">
                <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                  class="iconImg" src="@/assets/img/workFlowTxt.png" alt="">
              </div>
              <div class="preview-cover" v-else-if="type == 'video'">
                <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                  class="iconImg" src="@/assets/img/workFlowVideo.png" alt="">
              </div>
              <div class="preview-cover" v-else-if="type == 'default' || type == 'ppt' || type == 'zip'">
                <img @click="visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno)"
                  class="iconImg" src="@/assets/img/workFlowOther.png" alt="">
              </div>
              <div class="preview-cover ccc" v-else-if="type == 'pic' && documentType != 0"
                @click.stop="ceshiEvent2(url, type, sfilename)">

              </div>
            </div>
          </template>
        </van-uploader>
      </div>
    </van-dialog>
    <van-dialog v-model="showViewFile" title="文件查看" show-cancel-button class="showViewFileBox">
      <div v-if="showViewFile" style="width: 100%;height: 100%;">
        <iframe :src="viewFileUrl" frameborder="0" style="width: 100%;height: 100%;"></iframe>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Toast, Dialog, Notify } from 'vant'
import ImagesPreview from './ImagesPreview.vue';
import * as imageConversion from 'image-conversion'
import { upLoadBase64FileFixName, deleteFile, getAtFileOnLineUrl } from "@api/wxjx.js";
import { upLoadFile, getFileSvrUrl } from '@api/wx.js'
import { createGguid } from '@/utils'
import {
  getWFAttFileList
} from "@api/workFlow";
export default {
  components: {
    ImagesPreview,
  },
  props: {
    // 基本信息
    formConfig: {
      type: Object,
      default: () => { },
    },
    atfileinfo: {
      type: String,
      default: "",
    },
    atfilenamelist: {
      type: String,
      default: "",
    },
    attfile_fileext_list: {
      type: String,
      default: "",
    },
    canedit_file_when_newflow: {
      type: Boolean,
      default: false
    },
    forbid_upload_file: {
      type: Boolean,
      default: false
    },
    forbid_delete_file: {
      type: Boolean,
      default: false
    },
    canedit_file_when_checkflow: {
      type: Boolean,
      default: false
    },
    app_can_upload_allfile: {
      type: Boolean,
      default: false
    },
    tuPianZhiLiang: {
      type: Number,
      default: 500
    },
  },
  data() {
    const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo)
      : this.$route.query.formoutSize == '1' ? { userid: 1, username: 'admin' }// 外部人员打开单据时用到
        : {}
    return {
      userInfo,
      showWrapStatus: true,
      fileList: [],
      fileList2: [],
      fileList3: [],
      atFileList: [],
      filedLenth: 0,
      filedObj: {},
      isVisible: false,
      imageUrl: '',
      showPreview: false,
      previewIndex: 0,
      imageList: [],
      ischangepdf: false,
      showPackageFile: false,
      packageFileList: [],
      packageFileTit: "",
      packageFileValue: {},
      packageFileKey: 0,
      showViewFile: false,
      viewFileUrl: ""
    }
  },
  watch: {
    atfilenamelist(n) {
      this.getappendix();
    }
  },
  created() {
    this.getappendix();
  },
  computed: {
    formname() {
      return this.$route.query.formname
    },
    formautoid() {
      return this.$route.query.formautoid
    },
    mautoid() {
      return this.$route.query.mautoid
    },
    nodeid() {
      return this.$route.query.nodeid
    },
    saveormodify() {
      return this.$route.query.saveormodify
    },
    // 0是没意义的，一般是新增
    // 1：待我审批
    // 2：我发起的
    // 3：我已审批
    // 4：被撤销的
    // 5：未提交的
    // 6：抄送
    documentType() {
      return this.$route.query.documentType || 0
    },
    m_ischeck() {
      const parmsMIscheck = this.$route.query.m_ischeck
      if (typeof parmsMIscheck != 'undefined') {
        if (typeof parmsMIscheck == 'string') {
          return parmsMIscheck == 'true'
        } else {
          return parmsMIscheck;
        }
      } else {
        return false;
      }
    },
    canUploadFile() {
      if (this.documentType != 0) {
        if (this.canedit_file_when_checkflow) {
          return !this.forbid_upload_file
        } else {
          return false;
        }
      } else {
        return !this.forbid_upload_file
      }
    },
    canDelFile() {
      if (this.documentType != 0) {
        if (this.canedit_file_when_checkflow) {
          return !this.forbid_delete_file;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    computedScrollable() {
      return (str) => {
        if (str && typeof str == 'string') {
          let strLen = str.length;
          let count = 0;
          for (let i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) >= 0x4e00 && str.charCodeAt(i) <= 0x9fff) {
              count++;
            }
          }
          let engLen = strLen - count;
          let allLen = count * 2 + engLen;
          if (allLen >= 12) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    }
  },
  methods: {
    clickFj(value, key) {
      if (this.formConfig.packagefile) {
        this.packageFileValue = value;
        this.packageFileKey = key;
        this.packageFileTit = value.sfilename;
        this.showPackageFile = true;
        if (this.atFileList[this.packageFileKey].list.length > 0) {
          this.packageFileList = this.atFileList[this.packageFileKey].list
        }
      }
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.saveormodify != 'save') {
          setTimeout(async () => {
            this.atFileList[this.packageFileKey].list = this.packageFileList;
            await this.saveAinfoData(this.mautoid)
            this.packageFileList = [];
            this.getappendix();
            this.showPackageFile = false;
            done();
          }, 36)
        } else {
          this.atFileList[this.packageFileKey].list = this.packageFileList;
          this.packageFileList = [];
          this.jsuanFjian();
          this.showPackageFile = false;
          done();
        }
      } else {
        this.packageFileList = [];
        this.showPackageFile = false;
        done();
      }
    },
    handleIndexChange(index) {
      console.log("当前查看的图片索引:", index);
    },
    ceshiEvent(url, type, sfilename) {
      // console.log(url)
      let newArr = this.fileList.filter((val) => {
        return val.type == 'pic'
      })
      let imagesArr = newArr.map((val) => {
        return val.url
      })
      const index = newArr.findIndex(obj => obj.url === url);
      // fileList
      this.imageList = imagesArr;
      this.previewIndex = index;
      this.showPreview = true;
    },
    ceshiEvent2(url, type, sfilename) {
      if (this.formConfig.packagefile) {
        let newArr = this.atFileList[this.packageFileKey].list.filter((val) => {
          return val.type == 'pic'
        })
        let imagesArr = newArr.map((val) => {
          return val.url
        })
        const index = imagesArr.findIndex(obj => obj === url);
        this.imageList = imagesArr;
        this.previewIndex = index;
        this.showPreview = true;
      } else {
        let newArr = this.atFileList.filter((val) => {
          return val.list && val.list.length > 0 && val.list[0].type == 'pic'
        })
        let imagesArr = newArr.map((val) => {
          return val.list[0].url
        })
        const index = newArr.findIndex(obj => obj.list[0].url === url);

        this.imageList = imagesArr;
        this.previewIndex = index;
        this.showPreview = true;
      }


    },

    getFileNameWithoutExtension(filePath) {
      // 使用split('.')分割文件名和扩展名，然后取第一部分
      return filePath.split('.').slice(0, -1).join('.');
    },
    // atFileList
    async saveAinfoData(autoid) {
      if (!this.atfilenamelist) {
        let len = this.fileList.length;
        let lenNum = 0;
        let str = ''
        for (let obj of this.fileList) {
          let fileext = "";
          let fileName = "";
          if (obj && obj.file) {
            let n = obj.file.type.indexOf("/");
            fileext = obj.file.type.slice((n + 1));
            fileName = obj.file.name;
            if (fileext == 'jpeg') {
              fileext = 'jpg'
            }
          } else {
            fileext = obj.fileext;
            fileName = obj.name;
          }
          if ("mp4、wmv、rm、rmvb、mov、m4v、avi、flv".indexOf(fileext) != -1) {
            Toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true,
              message: '附件上传中...'
            });
            let params = {
              file: obj.file,
              upflag: 3,
              moduleno: this.formautoid,
              autoid: autoid,
              uploadpath: this.userInfo.formfilepath || 'WorkFlowFile',
              filename: fileName.substring(0, fileName.lastIndexOf(".")),
              fileext,
              username: this.userInfo.username,
            }
            const res = await upLoadFile(params)
            if (res == 'OK') {
              lenNum++
            } else {
              str = str + res
            }
            Toast.clear();
          } else {
            if (obj.content) {
              if (fileName == 'image.jpg') {
                fileName = new Date().getTime() + '.jpg'
              }
              if (fileName == 'image.jpeg') {
                fileName = new Date().getTime() + '.jpeg'
              }
              let params = {
                filebase64str: obj.content,
                upflag: 3,
                moduleno: this.formautoid,
                autoid: autoid,
                uploadpath: this.userInfo.formfilepath || 'WorkFlowFile',
                filename: fileName.substring(0, fileName.lastIndexOf(".")),
                fileext,
                username: this.userInfo.username,
                ischangepdf: this.ischangepdf ? 1 : 0
              }
              console.log(params, params.filebase64str.length, '图片上传1')
              // upLoadFile
              const res = await upLoadBase64FileFixName(params)
              if (res == 'OK') {
                lenNum++
              } else {
                str = str + res
              }
            }
          }
        }
        if (len == lenNum) {
          return '成功'
        } else {
          if (this.documentType != 0) {
            if (str) {
              Dialog.confirm({
                message: str
              }).then(() => { })
            }
            return '成功'
          } else {
            if (str) {
              Dialog.confirm({
                message: str
              }).then(() => { })
            }
            return '失败'
          }
        }
      } else {
        let text = '成功'
        let str = ''
        for (let obj of this.atFileList) {
          if (obj.list && obj.list.length > 0) {
            if (this.formConfig && this.formConfig.packagefile) {
              for (let packageObj of obj.list) {
                let fileext = '';
                if (packageObj.file) {
                  let n = packageObj.file.type.indexOf("/");
                  fileext = packageObj.file.type.slice((n + 1));
                  if (fileext == 'jpeg') {
                    fileext = 'jpg'
                  }
                } else {
                  fileext = packageObj.fileext
                }
                if ("mp4、wmv、rm、rmvb、mov、m4v、avi、flv".indexOf(fileext) != -1) {
                  let params = {
                    filebase64str: packageObj.file,
                    upflag: 3,
                    moduleno: this.formautoid,
                    autoid: autoid,
                    uploadpath: this.userInfo.formfilepath || 'WorkFlowFile',
                    filename: obj.sfilename + '_' + new Date().getTime(),
                    fileext,
                    username: this.userInfo.username,
                    packagetype: obj.sfilename
                  }
                  const res = await upLoadFile(params)
                  if (res != 'OK') {
                    str = str + res
                    text = '失败'
                  }
                } else {
                  if (packageObj.content) {

                    let params = {
                      filebase64str: packageObj.content,
                      upflag: 3,
                      moduleno: this.formautoid,
                      autoid: autoid,
                      uploadpath: this.userInfo.formfilepath || 'WorkFlowFile',
                      filename: obj.sfilename + '_' + new Date().getTime(),
                      fileext,
                      username: this.userInfo.username,
                      ischangepdf: this.ischangepdf ? 1 : 0,
                      packagetype: obj.sfilename
                    }
                    console.log(params, params.filebase64str.length, '图片上传2')
                    const res = await upLoadBase64FileFixName(params)
                    if (res != 'OK') {
                      str = str + res
                      text = '失败'
                    }
                  }
                }
              }
            } else {
              let fileext = '';
              if (obj.list[0].file) {
                let n = obj.list[0].file.type.indexOf("/");
                fileext = obj.list[0].file.type.slice((n + 1));
                if (fileext == 'jpeg') {
                  fileext = 'jpg'
                }
              } else {
                fileext = obj.list[0].fileext
              }
              if ("mp4、wmv、rm、rmvb、mov、m4v、avi、flv".indexOf(fileext) != -1) {
                let params = {
                  filebase64str: obj.list[0].file,
                  upflag: 3,
                  moduleno: this.formautoid,
                  autoid: autoid,
                  uploadpath: this.userInfo.formfilepath || 'WorkFlowFile',
                  filename: obj.sfilename,
                  fileext,
                  username: this.userInfo.username,
                }
                const res = await upLoadFile(params)
                if (res != 'OK') {
                  str = str + res
                  text = '失败'
                }
              } else {
                if (obj.list[0].content) {
                  let params = {
                    filebase64str: obj.list[0].content,
                    upflag: 3,
                    moduleno: this.formautoid,
                    autoid: autoid,
                    uploadpath: this.userInfo.formfilepath || 'WorkFlowFile',
                    filename: obj.sfilename,
                    fileext,
                    username: this.userInfo.username,
                    ischangepdf: this.ischangepdf ? 1 : 0
                  }
                  console.log(params, params.filebase64str.length, '图片上传2')
                  const res = await upLoadBase64FileFixName(params)
                  if (res != 'OK') {
                    str = str + res
                    text = '失败'
                  }
                }
              }
            }
          }
        }
        console.log(text, 'jhjekhfwkfjhj')
        if (text == '失败') {
          if (this.documentType != 0) {
            if (str) {
              Dialog.confirm({
                message: str
              }).then(() => { })
            }
            return "成功"
          } else {
            if (str) {
              Dialog.confirm({
                message: str
              }).then(() => { })
            }
          }

        }
        return text
      }

    },
    showWrapFun() {
      this.showWrapStatus = !this.showWrapStatus
    },
    getFileList() {
      // console.log(this.atfilenamelist,'this.filedObj')
      if (this.atfilenamelist) {
        const newUrl = {}
        if (this.formConfig.packagefile) {
          for (let obj of this.atFileList) {
            if (obj.list && obj.list.length > 0) {
              for (let c of obj.list) {

                if (c.url) {
                  newUrl["#masterfilecount_" + obj.sfilename] = obj.list.length
                } else {
                  newUrl["#masterfilecount_" + obj.sfilename] = 0
                }
              }

            } else {
              newUrl["#masterfilecount_" + obj.sfilename] = 0
            }
          }
        } else {
          for (let obj of this.atFileList) {
            if (obj.list && obj.list.length > 0) {
              if (obj.list[0].url) {
                newUrl["#masterfilecount_" + obj.sfilename] = 1
              } else {
                newUrl["#masterfilecount_" + obj.sfilename] = 0
              }
            } else {
              newUrl["#masterfilecount_" + obj.sfilename] = 0
            }
          }
        }
        // console.log(newUrl,'kjwehkfhkejhehhefhekfhfefh')
        this.filedObj = newUrl;
        // 
        return newUrl;
      } else {
        var index = 0;
        if (this.fileList && this.fileList.length > 0) {
          for (let i = 0; i < this.fileList.length; i++) {
            if (this.fileList[i].url) {
              index++;
            }
          }
        }
        this.filedLenth = index;
        return index;
      }
    },
    beforeRead(file) {
      let _this = this;
      console.log("压缩前", file)
      if (Array.isArray(file)) {
        // 一定要异步和for of 否则批量压缩会出错
        return new Promise(async (resolve, reject) => {
          let arr = [];
          let arr2 = [];
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '处理中...'
          });
          for (let item of file) {
            if (item.type.indexOf('image') != -1) {
              await imageConversion.compressAccurately(item, 500).then(res => {
                res = new File([res], item.name, { type: res.type, lastModified: Date.now() })
                console.log("多图片上传，压缩后", res)
                arr.push(res)
              })
            } else {
              arr2.push(item)
            }
          }
          let arr3 = [...arr, ...arr2]
          Toast.clear();
          resolve(arr3)
        })
      } else {
        if (file.type.indexOf('image') != -1) {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '处理中...'
          });
          return new Promise((resolve, reject) => {
            imageConversion.compressAccurately(file, 500).then(res => {
              res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
              console.log("单图片上传，压缩后", res)
              Toast.clear();
              resolve(res)
            })
          })
        } else {
          return new Promise((resolve, reject) => {
            resolve(file)
          })
        }
      }
    },

    async afterRead(file) {
      // console.log(this.fileList,this.atFileList,'wfwffff')
      if (this.saveormodify != 'save') {
        setTimeout(async () => {
          await this.saveAinfoData(this.mautoid)
          this.getappendix();
        }, 100)
      } else {
        this.jsuanFjian();
      }
    },
    beforeDelete2(a, b) {
      if (this.saveormodify != 'save') {
        if (a.autoid) {
          Dialog.confirm({
            message: '您是否确定删除？'
          }).then(() => {
            return new Promise((resolve, reject) => {
              deleteFile({
                dflag: 3,
                moduleno: this.formautoid,
                autoid: this.mautoid,
                filename: a.sfilename,
                fileext: a.fileext,
                file_name_guid: a.file_name_guid,
                downloadpath: this.userInfo.formfilepath || 'WorkFlowFile',
              }).then(async (res) => {
                await this.getappendix();
                this.packageFileList = this.atFileList[this.packageFileKey].list;
                resolve(true);
              }).catch(() => {
                resolve(false);
              });
            });
          })
        } else {
          return true
        }
      } else {
        setTimeout(() => {
          this.jsuanFjian();
        }, 100)
        return true;
      }
    },
    beforeDelete(a, b) {
      // console.log(a,'jhehfhhfehf')
      if (this.saveormodify != 'save') {
        if (a.autoid) {
          Dialog.confirm({
            message: '您是否确定删除？'
          }).then(() => {
            return new Promise((resolve, reject) => {
              deleteFile({
                dflag: 3,
                moduleno: this.formautoid,
                autoid: this.mautoid,
                filename: a.sfilename,
                fileext: a.fileext,
                file_name_guid: a.file_name_guid,
                downloadpath: this.userInfo.formfilepath || 'WorkFlowFile',
              }).then(async (res) => {
                await this.getappendix();
                resolve(true);
              }).catch(() => {
                resolve(false);
              });
            });
          })
        } else {
          return true
        }
      } else {
        setTimeout(() => {
          this.jsuanFjian();
        }, 100)
        return true;
      }
    },
    // 计算附件的数量
    jsuanFjian() {
      if (!this.atfilenamelist) {
        this.filedLenth = 0
        for (let obj of this.fileList) {
          if (obj.content) {
            this.filedLenth++
          }
        }
        this.$emit("getFileLen", this.filedLenth);
      } else {
        this.filedObj = {};
        if (this.formConfig.packagefile) {
          for (let obj of this.atFileList) {
            if (obj.list && obj.list.length > 0) {
              for (let c of obj.list) {
                if (c.content) {
                  this.filedObj["#masterfilecount_" + obj.sfilename] = obj.list.length
                } else {
                  this.filedObj["#masterfilecount_" + obj.sfilename] = 0
                }
              }

            } else {
              this.filedObj["#masterfilecount_" + obj.sfilename] = 0
            }
          }
        } else {
          for (let obj of this.atFileList) {
            if (obj.list && obj.list.length > 0) {
              if (obj.list[0].content) {
                this.filedObj["#masterfilecount_" + obj.sfilename] = 1
              } else {
                this.filedObj["#masterfilecount_" + obj.sfilename] = 0
              }
            } else {
              this.filedObj["#masterfilecount_" + obj.sfilename] = 0
            }
          }
        }

        this.$emit("getFileLen", this.filedObj);
      }
    },
    getFileExtension(url) {
      // 提取文件名部分
      const filename = url.split('/').pop(); // 获取URL最后一个部分
      const extension = filename.split('.').pop(); // 获取最后一个点之后的部分
      return extension.toLowerCase(); // 返回小写的后缀
    },
    visitFile(type, url, file_name_guid, formautoid, mautoid, sfilename, fileext, sflag, moduleno) {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '载入中...'
      });
      console.log(sflag, 'sflag')
      getAtFileOnLineUrl({
        file_name_guid: file_name_guid || '',
        dflag: sflag == 2 ? '2' : '3',
        moduleno: sflag == 2 ? moduleno : formautoid,
        autoid: mautoid,
        filename: sfilename,
        fileext: fileext,
        downloadpath: sflag == 2 ? (this.userInfo.attachfilepath || 'AttachFile') : (this.userInfo.formfilepath || 'WorkFlowFile'),
        username: this.userInfo.username
      }).then(res => {
        Toast.clear();
        if (res) {
          const extension = this.getFileExtension(res);
          if (extension.indexOf("pdf") != -1) {
            let link = decodeURIComponent(res);
            let host = link.slice(0, parseInt(link.indexOf('v8filesvr')))
            let url2 = host + 'pdf/web/viewer.html?file=' + encodeURIComponent(res);
            this.viewFileUrl = url2;
            this.showViewFile = true;
            this.$forceUpdate();
          } else {
            if (extension.indexOf("xls") != -1 || extension.indexOf("xlsx") != -1) {
              getFileSvrUrl({
                username: this.userInfo.username
              }).then(response => {
                if (isAndroid) {
                  //android终端
                  window.open(response + '/excelViews/index.html?url=' + res)
                } else if (isiOS) {
                  //ios终端
                  window.location.href = (response + '/excelViews/index.html?url=' + res)
                } else {
                  window.open(response + '/excelViews/index.html?url=' + res, '_blank')
                }
              })
            } else {
              if (isAndroid) {
                //android终端
                window.open(res)
              } else if (isiOS) {
                //ios终端
                window.location.href = res
              } else {
                window.open(res, '_blank')
              }
            }
          }
        } else {
          alert("链接不存在")
        }
      })
    },
    async getappendix() {
      if (this.mautoid && this.mautoid != "0") {
        await getWFAttFileList({
          formautoid: this.formautoid,
          mautoid: this.mautoid,
          username: this.userInfo.username,
        }).then((res) => {

          let arr = res.data;
          let arr1 = [];
          let arr2 = [];
          let arr3 = [];
          if (arr.length > 0) {
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].sflag == 0) {
                arr1.push(arr[i]);
              } else if (arr[i].sflag == 1) {
                arr2.push(arr[i]);
              } else if (arr[i].sflag == 2) {
                arr3.push(arr[i]);
              }
            }
          }
          // 假如有格式化附件
          if (this.atfilenamelist) {
            // 第一步先构造格式化附件列表
            let finallyFile = [];
            let namelists = this.atfilenamelist.split(",");
            namelists.forEach((item, id) => {
              let obj = {
                idx: id,
                moduleno: this.formautoid,
                sfilename: item,
                list: []
              };
              finallyFile.push(obj);
            });
            this.atFileList = finallyFile;

            let filedlist = arr1;
            filedlist.forEach((item) => {
              item.name = item.sfilename + item.fileext;
              let type = "";
              const ext = item.fileext
                ? item.fileext.split(".")[1]
                : item.fileext.slice(1).toString().toLowerCase(); // 后缀   
              if ("doc|docx".includes(ext.toLowerCase())) {
                type = "doc";
              } else if ("xlsx|xls".includes(ext.toLowerCase())) {
                type = "xls";
              } else if ("ppt|pptx".includes(ext.toLowerCase())) {
                type = "ppt";
              } else if ("pdf".includes(ext.toLowerCase())) {
                type = "pdf";
              } else if ("png|jpg|jpeg|emp".includes(ext.toLowerCase())) {
                type = "pic";
              } else if ("zip|rar".includes(ext.toLowerCase())) {
                type = "zip";
              } else if ("wmv|asf|asx|rm|rmvb|mp4|3gp|mov|m4v".includes(ext.toLowerCase())) {
                type = "video";
              } else {
                type = "default";
              }
              item.type = type;
              item.url = item.url + "?params=" + createGguid();
              item.status = "success"
            })
            filedlist.forEach((item) => {
              this.atFileList.forEach((value, index) => {
                if (this.formConfig.packagefile) {
                  if (value.sfilename == item.packagetype) {
                    value.list.push(item)
                  }
                } else {
                  if (value.sfilename == item.sfilename) {
                    value.list.push(item)
                  }
                }
              })
            })

          } else {

            this.fileList = arr1;
            this.fileList.forEach((item) => {
              item.name = item.sfilename + item.fileext;
              let type = "";
              const ext = item.fileext
                ? item.fileext.split(".")[1]
                : item.fileext.slice(1).toString().toLowerCase(); // 后缀
              if ("doc|docx".includes(ext.toLowerCase())) {
                type = "doc";
              } else if ("xlsx|xls".includes(ext.toLowerCase())) {
                type = "xls";
              } else if ("ppt|pptx".includes(ext.toLowerCase())) {
                type = "ppt";
              } else if ("pdf".includes(ext.toLowerCase())) {
                type = "pdf";
              } else if ("png|jpg|jpeg|emp".includes(ext.toLowerCase())) {
                type = "pic";
              } else if ("zip|rar".includes(ext.toLowerCase())) {
                type = "zip";
              } else if ("txt".includes(ext.toLowerCase())) {
                type = "txt";
              } else if ("wmv|asf|asx|rm|rmvb|mp4|3gp|mov|m4v".includes(ext.toLowerCase())) {
                type = "video";
              } else {
                type = "default";
              }
              item.type = type;
              item.url = item.url + "?params=" + createGguid();
              item.status = "success"
            });
            if (arr2.length > 0) {
              for (let i = 0; i < arr2.length; i++) {
                arr2[i].name = arr2[i].sfilename + arr2[i].fileext;
              }
              this.fileList2 = arr2;
              this.fileList2.forEach((item) => {
                item.name = item.sfilename + item.fileext;
                let type = "";
                const ext = item.fileext
                  ? item.fileext.split(".")[1]
                  : item.fileext.slice(1).toString().toLowerCase(); // 后缀
                if ("doc|docx".includes(ext.toLowerCase())) {
                  type = "doc";
                } else if ("xlsx|xls".includes(ext.toLowerCase())) {
                  type = "xls";
                } else if ("ppt|pptx".includes(ext.toLowerCase())) {
                  type = "ppt";
                } else if ("pdf".includes(ext.toLowerCase())) {
                  type = "pdf";
                } else if ("png|jpg|jpeg|emp".includes(ext.toLowerCase())) {
                  type = "pic";
                } else if ("zip|rar".includes(ext.toLowerCase())) {
                  type = "zip";
                } else if ("txt".includes(ext.toLowerCase())) {
                  type = "txt";
                } else if ("wmv|asf|asx|rm|rmvb|mp4|3gp|mov|m4v".includes(ext.toLowerCase())) {
                  type = "video";
                } else {
                  type = "default";
                }
                item.type = type;
                item.url = item.url + "?params=" + createGguid();
                item.status = "success"
              });
            }
            if (arr3.length > 0) {
              for (let i = 0; i < arr3.length; i++) {
                arr3[i].name = arr3[i].sfilename + arr3[i].fileext;
              }
              this.fileList3 = arr3;
              this.fileList3.forEach((item) => {
                item.name = item.sfilename + item.fileext;
                let type = "";
                const ext = item.fileext
                  ? item.fileext.split(".")[1]
                  : item.fileext.slice(1).toString().toLowerCase(); // 后缀
                if ("doc|docx".includes(ext.toLowerCase())) {
                  type = "doc";
                } else if ("xlsx|xls".includes(ext.toLowerCase())) {
                  type = "xls";
                } else if ("ppt|pptx".includes(ext.toLowerCase())) {
                  type = "ppt";
                } else if ("pdf".includes(ext.toLowerCase())) {
                  type = "pdf";
                } else if ("png|jpg|jpeg|emp".includes(ext.toLowerCase())) {
                  type = "pic";
                } else if ("zip|rar".includes(ext.toLowerCase())) {
                  type = "zip";
                } else if ("txt".includes(ext.toLowerCase())) {
                  type = "txt";
                } else if ("wmv|asf|asx|rm|rmvb|mp4|3gp|mov|m4v".includes(ext.toLowerCase())) {
                  type = "video";
                } else {
                  type = "default";
                }
                item.type = type;
                item.url = item.url + "?params=" + createGguid();
                item.status = "success"
              });
            }

          }
          this.$emit("getFileLen", this.getFileList());
        });
      } else {
        // 假如有格式化附件
        if (this.atfilenamelist) {
          let finallyFile = [];
          // 无返回则手动格式化
          let namelists = this.atfilenamelist.split(",");
          namelists.forEach((item, id) => {
            let obj = {
              idx: id,
              moduleno: this.formautoid,
              sfilename: item,
              list: [],
              packagefile: this.formConfig.packagefile
            };
            finallyFile.push(obj);
          });
          this.atFileList = finallyFile;
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.packageFileBox {
  /deep/.van-uploader__file-name {
    display: none !important;
  }
}

.keep-flow_block {
  width: 100%;
  margin-bottom: 25px;
  order: 5;

  .contentBox.packagefileCls {
    /deep/.van-uploader {
      pointer-events: none;
      width: 2.2rem !important;
      height: 2.2rem !important;
      overflow: hidden;
    }
  }

  .file-list-container {
    /deep/.van-uploader__wrapper--disabled {
      opacity: 1 !important;
    }

    .file-list-1 {
      background: #f1f1f1;
    }

    .file-list-header {
      height: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #e8edf2;

      span {
        font-size: 28px;
      }
    }

    .file-list-header-left {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .file-list-header-right {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 24px;
      padding-right: 12px;

      span {
        margin-left: 12px;

        &.ischangepdfClass {
          color: #1989fa !important;
        }
      }
    }
  }

  .keep-flow_wrapTitBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.42667rem;
    height: 92px;

    background: #fff;

    .h3 {
      color: #333333;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      margin: 0 !important;
      text-align: left;
      font-style: normal;
    }

    .upDownBtn {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.keep-flow_container {
  width: 100%;
  background: #fff;

  .contentBox {
    padding: 0 0.42667rem;
    padding-bottom: 20px;

    /deep/.van-uploader__preview {
      background: #f7f8fa !important;
    }

    /deep/.van-uploader__file-name {
      display: none !important;
    }
  }

  .content {
    text-align: justify;
    font-size: 28px;
    color: #374d58;
    border-top: 1px solid #eee;
    padding: 20px 0;
  }
}

.atFileListBox {
  display: flex;
  flex-wrap: wrap;

  .atFileListList {
    margin-right: 10px;
    margin-bottom: 0.2rem;
  }

  .atFileListListName {
    width: 100%;
    text-align: center;
    font-size: 28px;
  }
}

.preview-cover {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .iconImg {
    height: 90% !important;
    display: block !important;
  }
}

.preview-cover-footer {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 24px;
  background: rgba(0, 0, 0, 0.3);
  text-align: center;

  /deep/.van-notice-bar {
    background: rgba(0, 0, 0, 0.3) !important;
    padding: 0 !important;
    color: #fff !important;
    height: 36px !important;
    line-height: 36px !important;
    font-size: 24px;
  }

  /deep/.van-notice-bar__wrap {
    justify-content: center;
  }
}

.hideUploadBtn {
  /deep/.van-uploader__upload {
    display: none !important;
  }
}

.packageFileBox {
  padding: 0.5rem;
}

.showViewFileBox {
  width: 100%;
  height: 100%;
  top: 0 !important;
  transform: none;
  left: 0 !important;

  /deep/.van-dialog__header {
    display: none !important;
  }

  /deep/.van-dialog__content {
    width: 100%;
    height: calc(100% - 1.28rem);
  }
}
</style>